import { get, post } from "./fetch.core";
import type { PurchaseOrderDetail, PurchaseOrderListResponse } from "../types/purchaseOrder";

export function purchaseOrderIdString(v: unknown): string {
  if (v == null) return "";
  if (typeof v === "string") return v;
  return String(v);
}

export async function listCompletedPurchaseOrders(params: {
  paging: { page: number; size: number };
  nameNumberProductSupplier?: string;
}): Promise<PurchaseOrderListResponse> {
  const res = await post<PurchaseOrderListResponse>("/pos/purchaseOrder/list", params);
  return res.data;
}

export async function getPurchaseOrder(id: string): Promise<PurchaseOrderDetail> {
  const res = await get<PurchaseOrderDetail>(`/pos/purchaseOrder/single/${id}`);
  return res.data;
}
